import React from "react";

export default function YouTubeEmbed({ videoId, title = "Video", className = "" }) {
  const [loaded, setLoaded] = React.useState(false);
  if (!videoId) return null;
  return (
    <div className={`relative aspect-video overflow-hidden ring-1 ring-white/10 bg-black ${className}`} data-testid={`yt-embed-${videoId}`}>
      {loaded ? (
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          onClick={() => setLoaded(true)}
          className="absolute inset-0 w-full h-full group"
          data-testid="yt-play-btn"
          aria-label={`Play ${title}`}
        >
          <img
            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            alt={title}
            loading="lazy"
            className="w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-opacity"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-[color:var(--jk-gold)] bg-black/60 backdrop-blur flex items-center justify-center group-hover:bg-[color:var(--jk-gold)] transition-colors">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-[color:var(--jk-gold)] group-hover:text-black ml-1">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </div>
        </button>
      )}
    </div>
  );
}
